export const Colours = {
    midnightGreen: "#014849",
};
